<div class="chat-container">
  <div *ngIf="messages.length > 0" class="d-flex justify-content-end w-75">
    <button
      (click)="showConfirmationModal()"
      data-bs-target="#confirmation-modal"
      data-bs-toggle="modal"
      size="md"
      tds-button
      variant="secondary"
    >
      <tds-icon name="add" />
      {{ 'CHATBOT.NEW_CONVERSATION' | translate }}
    </button>
    <app-confirmation-modal
      (action)="confirmationModalContent.action()"
      [buttonText]="confirmationModalContent.buttonText"
      [message]="confirmationModalContent.message"
      [title]="confirmationModalContent.title"
    ></app-confirmation-modal>
  </div>
  <div
    *ngIf="messages.length === 0"
    class="d-flex flex-column align-items-center justify-content-center w-100 mt-5"
  >
    <img [ngSrc]="getSmartToyIconSrc()" alt="Smart Toy" height="65" width="65" />
    <div
      class="d-flex align-items-center justify-content-center gap-3 px-4 w-messages mt-3 fs-6 row"
    >
      <div
        (click)="askQuickQuestion('CHATBOT.QUESTION_PROMPT_1')"
        (keydown)="askQuickQuestion('CHATBOT.QUESTION_PROMPT_1')"
        [isClickable]="true"
        class="d-flex flex-column p-3 col-md-3 col-sm-7 h-question"
        tds-tile
      >
        <tds-icon name="description" size="sm" variant="info" />
        <span class="mt-1" tds-typography variant="body-2">{{
          'CHATBOT.QUESTION_PROMPT_1' | translate
        }}</span>
      </div>
      <div
        (click)="askQuickQuestion('CHATBOT.QUESTION_PROMPT_2')"
        (keydown)="askQuickQuestion('CHATBOT.QUESTION_PROMPT_2')"
        [isClickable]="true"
        class="d-flex flex-column p-3 col-md-3 col-sm-7 h-question"
        tds-tile
      >
        <tds-icon name="gavel" size="sm" variant="green" />
        <span class="mt-1" tds-typography variant="body-2">{{
          'CHATBOT.QUESTION_PROMPT_2' | translate
        }}</span>
      </div>
      <div
        (click)="askQuickQuestion('CHATBOT.QUESTION_PROMPT_3')"
        (keydown)="askQuickQuestion('CHATBOT.QUESTION_PROMPT_3')"
        [isClickable]="true"
        class="d-flex flex-column p-3 col-md-3 col-sm-7 h-question"
        tds-tile
      >
        <tds-icon name="star" size="sm" variant="yellow" />
        <span class="mt-1" tds-typography variant="body-2">{{
          'CHATBOT.QUESTION_PROMPT_3' | translate
        }}</span>
      </div>
    </div>
  </div>
  <div
    #messagesContainer
    class="messages-container d-flex flex-column-reverse overflow-auto w-messages h-75"
  >
    <div *ngIf="robotThinking || displayedMessage" class="d-inline-flex">
      <div class="robot-icon">
        <img [ngSrc]="getSmartToyIconSrc()" alt="Smart Toy" height="25" width="25" />
      </div>
      <div *ngIf="robotThinking" class="d-flex flex-column message px-3 ms-1 received">
        <div class="d-inline-flex mt-2 mb-2">
          <div class="loader-dot bg-dark rounded-circle mt-1 mb-1 p-1"></div>
          <div class="loader-dot bg-dark rounded-circle m-1 p-1"></div>
          <div class="loader-dot bg-dark rounded-circle mt-1 mb-1 p-1"></div>
        </div>
      </div>
      <div *ngIf="displayedMessage" class="message received p-3 my-1">
        <markdown [data]="displayedMessage"></markdown>
      </div>
    </div>

    <div *ngFor="let msg of messages; let i = index" class="d-flex flex-column">
      <div *ngIf="displayDate(msg)" class="d-flex justify-content-center align-items-center mb-1">
        <hr class="hr-date" />
        <span class="message-date">{{ msg.date }}</span>
        <hr class="hr-date" />
      </div>
      <!-- Message de type QUESTION -->
      <div *ngIf="msg.type === 'QUESTION'" class="message p-3 my-1 sent">
        {{ msg.question }}
      </div>
      <div *ngIf="msg.date" class="d-flex justify-content-end">
        <span class="message-time">{{ msg.time }}</span>
      </div>
      <!-- Message de type ANSWER -->
      <div *ngIf="msg.type === 'ANSWER'" class="d-inline-flex">
        <div class="robot-icon">
          <img [ngSrc]="getSmartToyIconSrc()" alt="Smart Toy" height="25" width="25" />
        </div>
        <div class="d-flex flex-column">
          <div *ngIf="msg.type === 'ANSWER'" class="d-flex flex-column message p-3 ms-2 received">
            <markdown [data]="msg.answer"></markdown>
            <ag-grid-angular
              *ngIf="msg.showTable"
              #agGrid
              style="width: 100%; height: 300px; margin-bottom: 1rem;"
              class="ag-theme-alpine"
              [rowData]="msg.tableRowData"
              [columnDefs]="msg.tableColumnDefs"
            ></ag-grid-angular>
            <ng-container *ngIf="msg.showTable">
              <button
                (click)="exportTableToExcelByIndex(i)"
                tds-button
                size="md"
                variant="secondary"
                style="align-self: flex-end; margin-bottom: 0.5rem;"
              >
                <tds-icon name="download" size="md" />
                Download to Excel
              </button>
            </ng-container>
          </div>
          <div class="d-inline-flex align-items-center justify-content-end w-75 mt-1">
            <button
              (click)="copyMessageToClipboard(msg.answer)"
              label="Copy this answer"
              title="Copy this answer"
              tds-icon-button
            >
              <tds-icon name="content_copy" size="md" variant="secondary" />
            </button>
            <button
              (click)="rateAnswer(msg, AnswerReaction.LIKED)"
              *ngIf="
                msg.answerReactions === undefined || msg.answerReactions === AnswerReaction.LIKED
              "
              label="Like this answer"
              title="Like this answer"
              [disabled]="msg.answerReactions === AnswerReaction.LIKED"
              tds-icon-button
            >
              <tds-icon name="thumb_up" size="md" variant="secondary" />
            </button>
            <span *ngIf="msg.answerReactions === AnswerReaction.LIKED" class="good-rating-text"
              >You liked this answer</span
            >

            <button
              *ngIf="
                msg.answerReactions === undefined || msg.answerReactions === AnswerReaction.DISLIKED
              "
              (click)="rateAnswer(msg, AnswerReaction.DISLIKED)"
              label="Dislike this answer"
              title="Dislike this answer"
              [disabled]="msg.answerReactions === AnswerReaction.DISLIKED"
              tds-icon-button
            >
              <tds-icon name="thumb_down" size="md" variant="secondary" />
            </button>
            <span *ngIf="msg.answerReactions === AnswerReaction.DISLIKED" class="bad-rating-text"
              >You disliked this answer</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-center w-100 mb-3">
    <button
      (click)="stopGeneration()"
      *ngIf="displayedMessage !== ''"
      class="mx-2"
      size="md"
      tds-button
      variant="secondary"
    >
      {{ 'CHATBOT.STOP_GENERATING' | translate }}
    </button>
  </div>
  <div class="d-flex align-items-center justify-content-center w-100 mb-3"></div>

  <div class="d-inline-flex justify-content-between align-items-end w-messages mb-3">
    <div class="d-flex align-items-center">
      <tds-tag>{{ 'CHATBOT.WARNING_GENERATED_MESSAGE' | translate }}</tds-tag>
    </div>
  </div>
  <div class="w-messages">
    <tds-form-field>
      <textarea
        #questionInput
        (input)="autoGrow($event)"
        (keydown.enter)="sendMessage(); $event.preventDefault()"
        [(ngModel)]="messageToSend.question"
        class="w-100"
        rows="1"
        data-hj-allow
        placeholder="{{ 'CHATBOT.QUESTION_PLACEHOLDER' | translate }}"
        tds-form-field-item
      ></textarea>
      <tds-form-field-suffix>
        <button (click)="sendMessage()" label="Send message" size="lg" tds-icon-button>
          <tds-icon name="send"></tds-icon>
        </button>
      </tds-form-field-suffix>
    </tds-form-field>
  </div>
  <div class="w-messages context-prompt">
    {{ 'CHATBOT.CONTEXT_PROMPT' | translate }}
  </div>
</div>
